import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Reusable full-screen busy overlay.
 *
 * Dims the whole viewport with a frosted-glass blur and shows a small white
 * card with a circular ring spinner in the center. Used to block input and give
 * visible feedback during blocking operations (e.g. bulk multi-select delete).
 *
 * Visibility is controlled by the caller with *ngIf, mirroring how <vf-spinner>
 * is used, e.g.:
 *   <vf-overlay-loader *ngIf="isBulkProcessing"></vf-overlay-loader>
 *
 * Styles are self-contained (no Tailwind/Bootstrap utility dependency) so it
 * renders identically everywhere it is used.
 */
@Component({
  selector: 'vf-overlay-loader',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="vf-overlay-loader" aria-live="polite" aria-busy="true">
      <div class="vf-overlay-loader__card">
        <div class="vf-overlay-loader__spinner"></div>
      </div>
    </div>`,
  styles: [`
    .vf-overlay-loader {
      position: fixed;
      inset: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.65);
      -webkit-backdrop-filter: blur(2px);
      backdrop-filter: blur(2px);
    }
    .vf-overlay-loader__card {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      background: #fff;
      border-radius: 6px;
      border: 1px solid rgb(229, 231, 235);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
    .vf-overlay-loader__spinner {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid rgb(229, 231, 235);
      border-top-color: rgb(51, 65, 85);
      animation: vf-overlay-loader-spin 1s linear infinite;
    }
    @keyframes vf-overlay-loader-spin {
      100% { transform: rotate(360deg); }
    }
  `]
})
export class OverlayLoaderComponent {
  constructor() { }
}
